import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BusinessSignUpComponent } from './business-sign-up/business-sign-up.component';
import { CustomerSignUpComponent } from './customer-sign-up/customer-sign-up.component';
import { SignUpComponent } from './sign-up/sign-up.component';

const routes: Routes = [
  {
    path: '',
    component: SignUpComponent
  },
  {
    path: 'customer',
    component: CustomerSignUpComponent
  },
  {
    path: 'business',
    component: BusinessSignUpComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthCheckRoutingModule {}
